import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { KaryakartaInterface } from "../../karyakarta.interface";
import { KARYAKARTA_CONSTANT } from "../constant/karyakarta.constant";
import { PAGE_CONFIG } from "../../../common/constant/pageconfig.constant";

@Injectable({
  providedIn: "root",
})
export class KaryakartaService {
  requestOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "my-auth-token",
    }),
  };

  constructor(private httpClient: HttpClient) {}

  //soft delete
  public updateData(karyakartaData: KaryakartaInterface) {
    let karyakartaId = karyakartaData.id;
    return this.httpClient.put(
      `${KARYAKARTA_CONSTANT.KARYAKARTA_DATA}/${karyakartaId}`,
      karyakartaData
    );
  }

  public getKaryakartaCount() {
    return this.httpClient.get(KARYAKARTA_CONSTANT.KARYAKARTA_COUNT);
  }

  // public temp() {
  //   return this.httpClient.get(`${KARYAKARTA_CONSTANT.KARYAKARTA_LIST}`);
  // }

  public getKaryakarta() {
    return this.httpClient.post(`${KARYAKARTA_CONSTANT.KARYAKARTA_LIST}`, {});
  }

  public createKaryakartaData(karyakartaData: KaryakartaInterface) {
    return this.httpClient.post(
      KARYAKARTA_CONSTANT.KARYAKARTA_DATA,
      karyakartaData
    );
  }

  public getCast() {
    return this.httpClient.get(`${KARYAKARTA_CONSTANT.CAST}`);
  }

  public getsubCastwithCast(castId: any) {
    return this.httpClient.get(
      `${KARYAKARTA_CONSTANT.SUBCAST_WITH_CAST}/${castId}`
    );
  }

  public getKaryakartaEdit(karyakartaId: any) {
    return this.httpClient.get(
      `${KARYAKARTA_CONSTANT.KARYAKARTA_DATA}/${karyakartaId}`
    );
  }

  public updateKaryakartaData(karyakartaData: KaryakartaInterface) {
    let karyakartaId = karyakartaData.id;
    return this.httpClient.put(
      `${KARYAKARTA_CONSTANT.KARYAKARTA_DATA}/${karyakartaId}`,
      karyakartaData
    );
  }

  public getTopKaryakartas(filters) {
    return this.httpClient.post(KARYAKARTA_CONSTANT.KARYAKARTA_LIST, filters);
  }

  public changeUserStatus(user) {
    return this.httpClient.put(
      `${KARYAKARTA_CONSTANT.USER_CHANGE_STATUS}/${user.id}`,
      user
    );
  }

  public getKaryakartaData() {
    return this.httpClient.get(KARYAKARTA_CONSTANT.KARYAKARTA_DATA);
  }

  public deleteKaryakartaData(karyakartaId: any) {
    return this.httpClient.delete(
      `${KARYAKARTA_CONSTANT.KARYAKARTA_DATA}/${karyakartaId}`
    );
  }

  public totalcount() {
    return this.httpClient.get(`${KARYAKARTA_CONSTANT.TOTAL_COUNT}`);
  }

  public getPageConfig() {
    return this.httpClient.get(PAGE_CONFIG.Karyakarta_Page);
  }

  public userCheck(obj) {
    return this.httpClient.post(`${KARYAKARTA_CONSTANT.USER_CHECK}`, obj);
  }
  public restoreRecord(rowData: any) {
    return this.httpClient.patch(`/user/restore/${rowData.id}`, {});
  }

}
